import _classCallCheck from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import FirebaseNodeSanitizerInstance from "./FirebaseNodeSanitizer";
import FirebaseBaseSession from "./FirebaseBaseSession";
import * as log from "loglevel";
import { getDatabase, off, onChildAdded, onChildRemoved, onDisconnect, onValue, push, ref, remove, serverTimestamp, set } from "firebase/database";

var FirebaseGlobalPresenceSession = /*#__PURE__*/function (_FirebaseBaseSession) {
  _inherits(FirebaseGlobalPresenceSession, _FirebaseBaseSession);

  function FirebaseGlobalPresenceSession(userName, id) {
    var _this;

    _classCallCheck(this, FirebaseGlobalPresenceSession);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FirebaseGlobalPresenceSession).call(this, id));
    _this.userName = userName;
    return _this;
  }

  _createClass(FirebaseGlobalPresenceSession, [{
    key: "addUserToPresenceNode",
    value: function addUserToPresenceNode(addUserToGlobalPresenceNodeHandler) {
      var _this2 = this;

      this.removeUserFromPresenceNodePromise().then(function () {
        addPresence();
      }).catch(function (error) {
        log.error("error removing node: " + error);
        addPresence();
      });

      var addPresence = function addPresence() {
        log.trace("start adding user to global presence Node!");
        var pushNode = push(_this2.getReference("g", FirebaseNodeSanitizerInstance.encodeKey(_this2.userName)));
        _this2.presenceNode = pushNode;
        onDisconnect(pushNode).remove().catch(function (err) {
          if (err) {
            log.error("could not establish onDisconnect event", err);
          }
        });
        var pushNodeContent = {
          t: serverTimestamp()
        };
        set(pushNode, pushNodeContent).then(function () {
          log.trace("added user to global presence Node!");

          if (!addUserToGlobalPresenceNodeHandler) {
            return;
          }

          addUserToGlobalPresenceNodeHandler();
        }).catch(function (error) {
          if (error) {
            log.error("error adding session into global precense node: " + error);
          } else {
            log.trace("user added to global presence Node.");
          }

          if (!addUserToGlobalPresenceNodeHandler) {
            return;
          }

          addUserToGlobalPresenceNodeHandler(error);
        });
      };
    }
  }, {
    key: "addUserToPresenceNodeWithLocation",
    value: function addUserToPresenceNodeWithLocation(location, addUserToGlobalPresenceNodeHandler) {
      var _this3 = this;

      this.removeUserFromPresenceNodeWithLocationPromise(location).then(function () {
        addPresence();
      }).catch(function (error) {
        log.error("error removing node: " + error);
        addPresence();
      });

      var addPresence = function addPresence() {
        log.trace("start adding user to global presence Node!");
        var pushNode = push(_this3.getReference("gl", location + "/" + FirebaseNodeSanitizerInstance.encodeKey(_this3.userName)));
        _this3.presenceNode = pushNode;
        onDisconnect(pushNode).remove().catch(function (err) {
          if (err) {
            log.error("could not establish onDisconnect event", err);
          }
        });
        var pushNodeContent = {
          t: serverTimestamp()
        };
        set(pushNode, pushNodeContent).then(function () {
          log.trace("added user to global presence Node!");

          if (!addUserToGlobalPresenceNodeHandler) {
            return;
          }

          addUserToGlobalPresenceNodeHandler();
        }).catch(function (error) {
          if (error) {
            log.error("error adding session into global precense node: " + error);
          } else {
            log.trace("user added to global presence Node.");
          }

          if (!addUserToGlobalPresenceNodeHandler) {
            return;
          }

          addUserToGlobalPresenceNodeHandler(error);
        });
      };
    }
  }, {
    key: "removeUserFromPresenceNode",
    value: function removeUserFromPresenceNode(removeFromGlobalPresenceHandler) {
      this.removeUserFromPresenceNodePromise().then(removeFromGlobalPresenceHandler).catch(function (error) {
        log.error("error removing usring from presence node: " + error);
        removeFromGlobalPresenceHandler(error);
      });
    }
  }, {
    key: "removeUserFromPresenceNodeWithLocation",
    value: function removeUserFromPresenceNodeWithLocation(location, removeFromGlobalPresenceHandler) {
      this.removeUserFromPresenceNodeWithLocationPromise(location).then(removeFromGlobalPresenceHandler).catch(function (error) {
        log.error("error removing usring from presence node: " + error);
        removeFromGlobalPresenceHandler(error);
      });
    }
  }, {
    key: "attachGlobalRosterListener",
    value: function attachGlobalRosterListener(globalRosterListener) {
      var database = getDatabase(this.firebaseApp);
      var roomStateRef = ref(database, "cs/g/" + this.firebaseSettings.prefix);
      onChildAdded(roomStateRef, function (snapshot) {
        globalRosterListener({
          type: "add",
          value: FirebaseNodeSanitizerInstance.decodeKey(snapshot.key)
        });
      });
      onChildRemoved(roomStateRef, function (snapshot) {
        globalRosterListener({
          type: "remove",
          value: FirebaseNodeSanitizerInstance.decodeKey(snapshot.key)
        });
      });
    }
  }, {
    key: "attachGlobalRosterListenerWithLocation",
    value: function attachGlobalRosterListenerWithLocation(location, globalRosterListener) {
      var database = getDatabase(this.firebaseApp);
      var roomStateRef = ref(database, "cs/gl/" + this.firebaseSettings.prefix + "/" + location);
      onChildAdded(roomStateRef, function (snapshot) {
        globalRosterListener({
          type: "add",
          value: FirebaseNodeSanitizerInstance.decodeKey(snapshot.key)
        });
      });
      onChildRemoved(roomStateRef, function (snapshot) {
        globalRosterListener({
          type: "remove",
          value: FirebaseNodeSanitizerInstance.decodeKey(snapshot.key)
        });
      });
    }
  }, {
    key: "detachGlobalRosterListener",
    value: function detachGlobalRosterListener() {
      var database = getDatabase(this.firebaseApp);
      var roomStateRef = ref(database, "cs/g/" + this.firebaseSettings.prefix);
      off(roomStateRef);
    }
  }, {
    key: "detachGlobalRosterListenerWithLocation",
    value: function detachGlobalRosterListenerWithLocation(location) {
      var database = getDatabase(this.firebaseApp);
      var roomStateRef = ref(database, "cs/gl/" + this.firebaseSettings.prefix + "/" + location);
      off(roomStateRef);
    }
  }, {
    key: "attachGlobalEventsListener",
    value: function attachGlobalEventsListener(globalEventsListener) {
      var database = getDatabase(this.firebaseApp);
      var globalEventsRef = ref(database, "cs/e/" + this.firebaseSettings.prefix + "/" + FirebaseNodeSanitizerInstance.encodeKey(this.userName));
      onValue(globalEventsRef, function (snapshot) {
        globalEventsListener(snapshot.val());
      });
    }
  }, {
    key: "detachGlobalEventsListener",
    value: function detachGlobalEventsListener() {
      var database = getDatabase(this.firebaseApp);
      var globalEventsRef = ref(database, "cs/e/" + this.firebaseSettings.prefix + "/" + FirebaseNodeSanitizerInstance.encodeKey(this.userName));
      off(globalEventsRef);
    }
  }, {
    key: "attachSystemLastEventListener",
    value: function attachSystemLastEventListener(systemLastEventListener) {
      var database = getDatabase(this.firebaseApp);
      var globalEventsRef = ref(database, "cs/se/" + this.firebaseSettings.prefix + "/le");
      onValue(globalEventsRef, function (snapshot) {
        systemLastEventListener(snapshot.val());
      });
    }
  }, {
    key: "attachSystemLastEventListenerWithLocation",
    value: function attachSystemLastEventListenerWithLocation(location, systemLastEventListener) {
      var database = getDatabase(this.firebaseApp);
      var globalEventsRef = ref(database, "cs/se/" + this.firebaseSettings.prefix + "/" + location);
      onValue(globalEventsRef, function (snapshot) {
        systemLastEventListener(snapshot.val());
      });
    }
  }, {
    key: "detachSystemLastEventListener",
    value: function detachSystemLastEventListener() {
      var database = getDatabase(this.firebaseApp);
      var globalEventsRef = ref(database, "cs/se/" + this.firebaseSettings.prefix + "/le");
      off(globalEventsRef);
    }
  }, {
    key: "detachSystemLastEventListenerWithLocation",
    value: function detachSystemLastEventListenerWithLocation(location) {
      var database = getDatabase(this.firebaseApp);
      var globalEventsRef = ref(database, "cs/se/" + this.firebaseSettings.prefix + "/" + location);
      off(globalEventsRef);
    }
  }, {
    key: "removeUserFromPresenceNodePromise",
    value: function removeUserFromPresenceNodePromise() {
      return remove(this.getReference("g", FirebaseNodeSanitizerInstance.encodeKey(this.userName)));
    }
  }, {
    key: "removeUserFromPresenceNodeWithLocationPromise",
    value: function removeUserFromPresenceNodeWithLocationPromise(location) {
      return remove(this.getReference("gl", location + "/" + FirebaseNodeSanitizerInstance.encodeKey(this.userName)));
    }
  }]);

  return FirebaseGlobalPresenceSession;
}(FirebaseBaseSession);

export { FirebaseGlobalPresenceSession as default };